import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_DELETE_VENUE_MUTATION = gql`
  mutation Post(
    $id: String!,
    $venueSlugName: String!,
    ) {
    postDeleteVenue(
      id: $id,
      venueSlugName: $venueSlugName,
      ) {
      isAuth
      isDeleted
      venueSlugName
      isUsed { eventSlugNames, artistSetSlugNames }
    }
  }
`;

const postDeleteVenue = async ({
  id,
  venueSlugName,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_DELETE_VENUE_MUTATION,
      variables: {
        id,
        venueSlugName,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postDeleteVenue: postDeleteVenueValidationData } } = result;

    if (postDeleteVenueValidationData) {
      return postDeleteVenueValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeleteVenueValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeleteVenue Error: ${error}`);
    return null;
  }
};

export default postDeleteVenue;
